import styled from 'styled-components';

export default styled.div`

    cursor: copy;
    padding-top: 0.5em;
        
    & input {
        border: none;
        color: ${(props) => props.theme.palette.blueGrey[700] };
        font-size: ${(props) => props.theme.fontSizes[6] };
        display: block;
        background: transparent;

        &:focus,
        &:active
        {
          border: none;
        }
    }
    `;



// WEBPACK FOOTER //
// ./src/components/styles/FlatInputShareMenu.js